
// eslint-disable-next-line import/prefer-default-export
export const ORDERS = {
    STATUS: {
        NEW: 'new',
        HIDDEN: 'hidden',
        IN_PRODUCTION: 'in_production',
        WELDING: 'welding',
        FINISHING: 'finishing',
        BUNDLING: 'bundling',
        READY: 'ready',
        SHIPPED: 'shipped',
    },
};



// WEBPACK FOOTER //
// ./src/constants/sales.js